
import { MaintenanceAspectEntityDecoratorBase } from './maintenance-aspect.decorator.base';


export class MaintenanceAspectEntityDecorator extends MaintenanceAspectEntityDecoratorBase {
  constructor() {
    super();
  }
}



